import React from 'react';
import { percentTextStyle, progressContainerStyle, progressFillStyle, waitTextStyle } from './AirtimePlanningStyles';
import Modal from '../../generic/modal/Modal';

const PlanProgress = ({ percentComplete, message }) => {
    return (
        <Modal
            height={147}
            width={391}
            modalBackgroundStyle={{ backgroundColor: 'rgba(0,0,0,0)' }}
            modalBodyStyle={{
                backgroundColor: '#FFFFFF',
                border: '1px solid #B3B3B3',
                borderRadius: 5,
                padding: 0,
                boxShadow: 'none'
            }}
            isShowing={true}
            showClose={false}
        >
            <div align='center' style={{ marginTop: 8 }}>
                <span style={waitTextStyle}>{window.translate('Please wait while the plan is generated...')}</span>
            </div>

            <div align='center' style={{ marginTop: 32 }}>
                {percentComplete ? (
                    <>
                        <div style={progressContainerStyle}>
                            <div
                                style={{
                                    position: 'absolute',
                                    marginLeft: 2,
                                    marginTop: 2
                                }}
                            >
                                <div style={progressFillStyle(percentComplete)} />
                            </div>
                        </div>

                        <div style={{ marginLeft: 338, marginTop: 3 }}>
                            <span style={percentTextStyle}>{Math.ceil(percentComplete * 100)}%</span>
                        </div>
                    </>
                ) : (
                    <div style={{ width: '90%', overflow: 'hidden' }}>{message}</div>
                )}
            </div>
        </Modal>
    );
};

export default PlanProgress;
